var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImplementSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "127px",
    viewBox: "0 0 147 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BTI_Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Research",
    transform: "translate(-149.000000, -2186.000000)",
    stroke: "#006AF9",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(151.000000, 2188.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.4193548,
    y1: 1,
    x2: 52.4193548,
    y2: 28,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.4193548,
    y1: 1,
    x2: 25.4193548,
    y2: 28,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.419355,
    y1: 48,
    x2: 142.419355,
    y2: 75,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.419355,
    y1: 48,
    x2: 115.419355,
    y2: 75,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.4193548,
    y1: 96,
    x2: 86.4193548,
    y2: 123,
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.4193548,
    y1: 96,
    x2: 59.4193548,
    y2: 123,
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-13",
    points: "81 16 97.0001407 0 113 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4193548,74 C38.4193548,84.493422 29.9127143,93 19.419215,93 C8.92599541,93 0.419354839,84.493422 0.419354839,74 C0.419354839,63.506578 8.92599541,55 19.419215,55 C29.9127143,55 38.4193548,63.506578 38.4193548,74 Z",
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4193548,74 C39.4193548,74 103.760599,69.5398788 96.9084866,-2.27373675e-13",
    id: "Stroke-17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplementSuccess);
export default __webpack_public_path__ + "static/media/Implement_success.f1a2fe29c0a361e48ef7b90297f047e3.svg";
export { ForwardRef as ReactComponent };